// Generated by ts-to-zod
import { z } from 'zod';

export const listInboxesQuerySchema = z.object({
  page: z.number().optional(),
});
